export * from './lib/browser-storage.service.module';

export { AccredibleBrowserStorageService } from './lib/browser-storage.service';
